export class Samsum {
  id: string;
  summary: string;
  dialogue: string;

  constructor(id: string, summary: string, dialogue: string) {
    this.id = id;
    this.summary = summary;
    this.dialogue = dialogue;
  }
}
